import { get, post, postImageAxios } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { getFormDataFromJSON, showToast } from "utils"
import {
  getIconsFailed,
  getIconsSuccess,
  getPlatformSettingsFailed,
  getPlatformSettingsSuccess,
  getSocialProfileSettingsFailed,
  getSocialProfileSettingsSuccess,
  getWebsiteConfigsFailed,
  getWebsiteConfigsSuccess,
  updatePlatformSettingsFailed,
  updatePlatformSettingsSuccess,
  updateSocialProfileSettingsFailed,
  updateSocialProfileSettingsSuccess,
  updateWebsiteConfigsFailed,
  updateWebsiteConfigsSuccess,
} from "./actions"
import {
  GET_ICONS,
  GET_PLATFORM_SETTINGS,
  GET_SOCIAL_PROFILE_SETTINGS,
  GET_WEBSITE_CONFIGS,
  UPDATE_PLATFORM_SETTINGS,
  UPDATE_SOCIAL_PROFILE_SETTINGS,
  UPDATE_WEBSITE_CONFIGS,
} from "./actionTypes"

function* getPlatformSettings({ payload: params }) {
  try {
    const response = yield get(`/vendor/${params.vendorId}/design`)
    yield put(getPlatformSettingsSuccess(response))
  } catch (error) {
    yield put(getPlatformSettingsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updatePlatformSettings({ payload: params }) {
  try {
    let thumbnail = null
    let background = null
    let brandImage = null

    if (params?.uploadThumbnailImage) {
      thumbnail = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.thumbnailImage)
      )
    }
    if (params?.uploadBgImage) {
      background = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.bgImage)
      )
    }
    if (params?.uploadBrandImage) {
      brandImage = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.brandImage)
      )
    }

    const response = yield post(
      `/admin/vendor/${params?.values?.vendor_id}/design`,
      {
        ...params?.values,
        ...(thumbnail ? { event_thumbnail_file: thumbnail[0] } : {}),
        ...(background ? { bg_image_file: background[0] } : {}),
        ...(brandImage ? { logo_file: brandImage[0] } : {}),
      }
    )

    yield put(updatePlatformSettingsSuccess(response))
    showToast("success", "Platform Settings Updated!", "Success")
  } catch (error) {
    yield put(updatePlatformSettingsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getIcons({ payload: params }) {
  try {
    const response = yield get("/design/menu/icons")
    yield put(getIconsSuccess(response))
  } catch (error) {
    yield put(getIconsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getSocialProfileSettings({ payload: params }) {
  try {
    const response = yield get(`/vendor/${params?.vendorId}/social-profile`)
    yield put(getSocialProfileSettingsSuccess(response))
  } catch (error) {
    yield put(getSocialProfileSettingsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateSocialProfileSettings({ payload: params }) {
  try {
    const response = yield post(
      `/admin/vendor/${params?.vendor_id}/social-profile`,
      params
    )
    yield put(updateSocialProfileSettingsSuccess(params))
    showToast("success", "Social Profile Settings Updated!", "Success")
  } catch (error) {
    yield put(updateSocialProfileSettingsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getWebsiteConfigs({ payload: params }) {
  try {
    const response = yield get("/website-configs", { params })
    yield put(getWebsiteConfigsSuccess(response))
  } catch (error) {
    yield put(getWebsiteConfigsFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateWebsiteConfigs({ payload: params }) {
  try {
    let { banner, logo, ...rest } = params
    if (params?.logo) {
      logo = yield postImageAxios("/file", getFormDataFromJSON(params?.logo))
    }
    if (params?.banner) {
      banner = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params?.banner)
      )
    }
    const response = yield post("/admin/website-configs", {
      ...rest,
      ...(!!logo ? { logo_file: logo[0] } : {}),
      ...(!!banner ? { banner_file: banner[0] } : {}),
    })

    yield put(updateWebsiteConfigsSuccess(response))
    showToast("success", "Configs saved!", "Success")
  } catch (error) {
    yield put(updateWebsiteConfigsFailed(error))
    showToast("error", error, "Error")
  }
}

function* platformSettingsSaga() {
  yield takeEvery(GET_PLATFORM_SETTINGS, getPlatformSettings)
  yield takeEvery(UPDATE_PLATFORM_SETTINGS, updatePlatformSettings)
  yield takeEvery(GET_ICONS, getIcons)
  yield takeEvery(GET_SOCIAL_PROFILE_SETTINGS, getSocialProfileSettings)
  yield takeEvery(UPDATE_SOCIAL_PROFILE_SETTINGS, updateSocialProfileSettings)
  yield takeEvery(GET_WEBSITE_CONFIGS, getWebsiteConfigs)
  yield takeEvery(UPDATE_WEBSITE_CONFIGS, updateWebsiteConfigs)
}

export default platformSettingsSaga
